import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import EditMenu from './pages/EditMenu';
import ListMenu from './pages/ListMenu';

const Menu = () => {
  return (
    <Routes>
      <Route path="/" element={<ListMenu />} />
      <Route path="/new" element={<EditMenu />} />
      <Route path="/:menuId" element={<EditMenu />} />
    </Routes>
  );
};

export default Menu;
